export default __webpack_public_path__ + "static/media/rhea-bg.ad47f0f1.png";